import { css } from 'styled-jsx/css';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { colors } from '../Theme';

const iconSize = '100px';
const spacingSize = '30px';
const styles = css`
  .box-container {
    display: flex;
    margin-bottom: 50px;
    flex-direction: column;
    align-items: center;
  }

  .box-container:first-of-type {
    margin-top: 40px;
  }

  .box-container:last-child {
    margin-bottom: 0;
  }

  .box-list {
    display: flex;
    margin: 0;
    padding: 30px 0;
    width: 100%;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    border-color: ${colors.ywgVeryLightPink};
    border-style: solid;
    border-width: 0;
    border-top-width: 1px;
  }

  .box-row {
    display: flex;
    justify-content: space-between;
  }

  .box-row__end {
    min-width: 25%;
  }

  .side-list {
    position: relative;
    list-style: none;
  }

  .side-item {
    padding-left: 15px;
  }

  .side-item::before {
    position: absolute;
    margin-left: -20px;
    content: '✔';
    color: ${colors.ywgPinkishOrange};
  }

  .side-item:not(:last-child) {
    margin-bottom: 15px;
  }

  .icon::before {
    content: '';
    width: 100%;
    height: calc(${iconSize} + 20px);
    flex-shrink: 0;
    background-position: 50% top;
    background-size: ${iconSize} ${iconSize};
    background-repeat: no-repeat;
  }

  .icon--luggages::before {
    background-image: url('/static/images/icons/luggages.svg');
  }

  .icon--a::before {
    background-image: url('/static/images/icons/letter-a.svg');
  }

  .icon--b::before {
    background-image: url('/static/images/icons/letter-b.svg');
  }

  .icon--c::before {
    background-image: url('/static/images/icons/letter-c.svg');
  }

  .icon--tooth::before {
    background-image: url('/static/images/icons/tooth.svg');
  }

  .icon--france::before {
    background-image: url('/static/images/icons/france.svg');
  }

  .icon--cool::before {
    background-image: url('/static/images/icons/cool.svg');
  }

  .icon--tickets::before {
    background-image: url('/static/images/icons/tickets.svg');
  }

  .icon--calendar::before {
    background-image: url('/static/images/icons/calendar.svg');
  }

  .icon--scales::before {
    background-image: url('/static/images/icons/scales.svg');
  }

  .icon--assistance::before {
    background-image: url('/static/images/icons/assistance.svg');
  }

  .icon--mountain::before {
    background-image: url('/static/images/icons/mountain.svg');
  }

  .icon--wheelchair::before {
    background-image: url('/static/images/icons/wheelchair.svg');
  }

  .icon--heart::before {
    background-image: url('/static/images/icons/heart.svg');
  }

  .icon--people::before {
    background-image: url('/static/images/icons/people.svg');
  }

  .emphasis {
    color: ${colors.ywgNavy};
    font-weight: 700;
  }

  @media (min-width: 1150px) {
    .box-container {
      flex-direction: row;
      margin-bottom: 40px;
    }

    .box-list {
      padding: 10px ${spacingSize};
      border-width: 0;
      border-left-width: 1px;
    }

    .main-list {
      width: 550px;
      flex-shrink: 0;
    }

    .side-list {
      padding-right: 0;
    }

    .icon::before {
      margin-right: ${spacingSize};
      width: 120px;
      background-position-y: center;
    }
  }
`;

const SideList = ({ items }) => {
  return items ? (
    <>
      <ul className="box-list side-list">
        {items.map((item, key) => (
          <li key={key} className="side-item">
            {item}
          </li>
        ))}
      </ul>
      <style jsx>{styles}</style>
    </>
  ) : null;
};

SideList.propTypes = {
  items: PropTypes.array
};

const Box = ({ icon, main, side }) => {
  const iconClasses = icon ? `icon icon--${icon}` : null;
  return (
    <>
      <div className={classnames('box-container', iconClasses)}>
        <ul className="box-list main-list">
          {main.map((item, key) => (
            <li
              className={classnames('box-row', {
                emphasis: item.type === 'important'
              })}
              key={key}
            >
              {item.textStartHref ? (
                <a href={item.textStartHref}>{item.textStart}</a>
              ) : (
                <span>{item.textStart}</span>
              )}
              {item.textEnd ? (
                <span className="box-row__end">{item.textEnd}</span>
              ) : null}
            </li>
          ))}
        </ul>
        <SideList items={side}></SideList>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

Box.propTypes = {
  icon: PropTypes.string,
  main: PropTypes.array.isRequired,
  side: PropTypes.array
};

export default Box;
